import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

/**
 * Campo para seleccionar archivo
 */
@Component({
    selector: 'app-file-input',
    template: `
      <div [formGroup]="form">
        <input
        [attr.type]="field.type"
        class="form-control"
        [attr.disabled]="field.disabled"
        [id]="field.name"
        [name]="field.name"
        [formControlName]="field.name"
        [ngClass]="{'is-invalid': isTouched && !isValid && field.required}" [attr.value]="field.value"
        [maxlength]="field.maxLength"
        [attr.pattern]="field.pattern"
        [min]="field.min"
        [max]="field.max"
        >
    `,
    standalone: false
})
export class FileInputComponent {
  /**
   * Campo del formulario
   */
  @Input() field: any = {};
  /**
   * Formulario
   */
  @Input() form!: UntypedFormGroup;

  /**
   * Indica si es valiod
   */
  get isValid(): any {
    return this.form.controls[this.field.name].valid;
  }
  /**
   * Indica si esta sucio
   */
  get isDirty(): any {
    return this.form.controls[this.field.name].dirty;
  }
  /**
   * Indica si fue tocado
   */
  get isTouched(): any {
    return this.form.controls[this.field.name].touched;
  }
  /**
   * Constructor
   *
   * @param dialog dialogo
   */
  constructor(
    private dialog: MatDialog
  ) {
  }

}
